import { Box, styled, useTheme } from '@mui/material';

import { Typography } from '@forethought-technologies/forethought-elements';

export const TextDivider = ({ text }: { text: string }) => {
  const { palette } = useTheme();

  return (
    <Box
      alignItems='center'
      boxSizing='border-box'
      display='flex'
      px='16px'
      width='100%'
    >
      <Divider />
      <Box px='8px' whiteSpace='nowrap'>
        <Typography color={palette.colors.grey[500]} variant='font12'>
          {text}
        </Typography>
      </Box>
      <Divider />
    </Box>
  );
};

const Divider = styled('hr')`
  border-width: 0;
  border-bottom-width: thin;
  border-color: ${({ theme }) => theme.palette.colors.grey[100]};
  width: 100%;
`;
